
import { firestoreReducer } from 'redux-firestore';
import { firebaseReducer } from 'react-redux-firebase'
import { combineReducers } from 'redux'
import verifyMalReducer from './verifyMalReducer'

const rootReducer = combineReducers({
    firestore: firestoreReducer,
    firebase: firebaseReducer,
    verifyMal: verifyMalReducer
})

export default rootReducer;